<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ack"> </p>
<p class="FM-Head-fmh"><span epub:type="pagebreak" id="pg_7" title="7"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></span></p>
<p class="FM-Text-No-Indent-fmtx1">The American Craft series and this book in particular would not have been possible without the support of many people, some of whom are specifically thanked below:</p>
<p class="FM-Text-fmtx">Editor Claire Eddy, whose patience during my recent tribulations gave me the time and confidence to write this novel properly.</p>
<p class="FM-Text-fmtx">Editorial assistants Bess Cozby and Kristin Temple for going pirate hunting with me.</p>
<p class="FM-Text-fmtx">Agent Robert Thixton for continuing to persevere.</p>
<p class="FM-Text-fmtx">Dominick Saponaro, Irene Gallo, and Peter Lutjen for the joy of seeing such wonderful cover illustrations and designs for my work.</p>
<p class="FM-Text-fmtx">Copy editors Anna Chang, Ivy McFadden, and Debbie Friedman for their obsession for detail.</p>
<p class="FM-Text-fmtx">The members of the Writers Group from Hell for journeying for a year with me from one chunk of text to the next, for the third time.</p>
<p class="FM-Text-fmtx">My brother Bill Doyle, whose research on climbing above twenty thousand feet was very important (so many ways to fail!).</p>
<p class="FM-Text-fmtx">My partner, Beth Delaney, who kept me alive so I could finish this trilogy.</p>
<p class="FM-Text-fmtx">Moira Fitzgibbons, who helped again with Latin, and who also advised on the appropriate handling of old manuscripts.</p>
<p class="FM-Text-fmtx">Colleen Cahill and the Library of Congress for the use of their map collection.</p>
<p class="FM-Text-fmtx">Robert O’Donoghue, Shannon McRae, and Angie Greene for their assistance with the prologue.</p>
<p class="FM-Text-fmtx">Tom Zanol for a helpful bit of Italian, and for lending me his name for the first book.</p>
<p class="FM-Text-fmtx"><span epub:type="pagebreak" id="pg_8" title="8">All the indie book bloggers who mentioned my work or allowed me to be their guest.</span></p>
<p class="FM-Text-fmtx">Among the many references I used, I’m particularly indebted to Lawrence Sutin’s <span class="ePub-I">Do What Thou Wilt: A Life of Aleister Crowley</span> (St. Martin’s Press, 2000).</p>
<p class="FM-Text-fmtx">Most of all, I’m grateful to the readers who’ve followed my craftspeople through these three books.</p>
<p class="FM-Text-fmtx">Thank you!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?5e69979b